// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Button, Tooltip, Typography } from '@mui/material';

// project imports
import useAuth from 'hooks/useAuth';
import useTwilioCall from 'hooks/useTwilioCall';

// Fixed strip height — MainLayout and Sidebar add this to their hardcoded
// 88px header offset while an impersonation session is active.
export const IMPERSONATION_BANNER_HEIGHT = 40;

// =============================|| IMPERSONATION BANNER ||============================= //

// Always-visible strip rendered inside the fixed AppBar (above the toolbar)
// while the session is a support-user impersonation, so it is unmistakable
// that actions run as the org's support account rather than a real user.
const ImpersonationBanner = () => {
    const theme = useTheme();
    const { impersonation, organizationMeta, logout } = useAuth();
    // Same guard as the profile menu's logout: tearing the session down
    // mid-call would strand the Twilio connection.
    const { isActive: isCallActive } = useTwilioCall();

    if (!impersonation) {
        return null;
    }

    const orgName = organizationMeta?.meta?.name || 'this organization';

    return (
        <Box
            sx={{
                height: `${IMPERSONATION_BANNER_HEIGHT}px`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 2,
                paddingX: 2,
                // Amber + near-black in both modes — the hazard combo stays high
                // contrast where warning.light/warning.dark text washed out.
                bgcolor: theme.palette.warning.dark,
                color: theme.palette.grey[900]
            }}
        >
            <Typography variant="subtitle2" sx={{ color: 'inherit' }} noWrap>
                Impersonating Apothedoc Support @ {orgName} — signed in as {impersonation.actor}
            </Typography>
            <Tooltip title={isCallActive ? 'Finish the active call before exiting impersonation' : ''}>
                <span>
                    <Button size="small" variant="outlined" color="inherit" disabled={isCallActive} onClick={logout}>
                        Exit
                    </Button>
                </span>
            </Tooltip>
        </Box>
    );
};

export default ImpersonationBanner;
